// Package imports:
import React from 'react';
// Component imports:
import Tabs from '../../ui-elements/Tabs/Tabs';
import PropertySearch from './PropertySearch/PropertySearch';
import HistoryButtonDropDown from '../HistoryButtonDropDown/HistoryButtonDropDown';
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import AssetsSearch from './AssetsSearch/AssetsSearch';
import GangverdSearch from './GangverdSearch/GangverdSearch';

interface IProps {
	isAuthenticated: boolean,
	bondsAllowed: boolean,
	individualAssetsAllowed: boolean
}

const PropertySearches: React.FC<IProps> = ({
	isAuthenticated,
	bondsAllowed,
	individualAssetsAllowed
}) => {
	return (
		<div className="main KCL_Fasteignir">
			<div className='section__body'>
				<div className='shell'>
					<HeadSection
						title={
							<>
								<h1>Fasteignir</h1>
								{isAuthenticated && <HistoryButtonDropDown />}
							</>
						}
					/>
				</div>
				<Tabs  
					tabsSize="lg"
					saveTabToUrl
					tabs={[{
						id: "Fasteignaskra",
						label: "Fasteignaskrá",
						component: <PropertySearch isAuthenticated={isAuthenticated} bondsAllowed={bondsAllowed} />
					}, {
						id: "Eignastada",
						label: "Eignastaða",
						component: <AssetsSearch isAuthenticated={isAuthenticated} individualAssetsAllowed={individualAssetsAllowed} />
					}, {
						id: "Gangverd",
						label: "Verðvísir Gangverðs",
						component: <GangverdSearch isAuthenticated={isAuthenticated} />
					}]}
					shellHead
				/>
			</div>
		</div>
	)
}

export default PropertySearches;